export const BASE_ROUTE = 'mpower-admin';
export const PATIENT_BASE_ROUTE = 'patient';
export const PATIENT_FORMS_BASE_ROUTE = 'patient-forms'
